
    import Dropdown from '@/components/dropdown/Dropdown.vue'
    import DropdownItem from '@/components/dropdown/DropdownItem.vue'
    import { Component, Vue, Prop } from 'vue-property-decorator'
    import { TimeUtil } from '@/helpers/TimeUtil'
    import { commonModule, companyModule, installationsModule } from '@/store/modules/store-accessor'
    import { templatesFilenameLanguage } from "@/helpers/data";
    import FileSaver from 'file-saver';
    import dayjs from 'dayjs';
    import ExportMenu from "@/components/ExportMenu/ExportMenu.vue";

    @Component({components: { Dropdown, DropdownItem, ExportMenu } })
    export default class InstallationsSideviewFilesTab extends Vue {
     @Prop() installation: Record<string, any>;

    isDowloadingFile = false;
    isDownloadingExport = false;

      tableheaders: any [] = [
        { text: this.$t("filename"), align: 'left', sortable: true, class: 'row-style', value: 'original_name' },
        { text: this.$t("notes"), sortable: true, align: 'left', class: 'row-style', value: 'notes' },
        { text: this.$t("uploadedBy"), sortable: true, align: 'left', class: 'row-style', value: 'created_by' },
        { text: this.$t("uploadedAt"), sortable: true, align: 'left', class: 'row-style', value: 'created_at' },
        { text: this.$t("size"), sortable: true, align: 'left', class: 'row-style', value: 'size' },
        { text: this.$t("actions"), align: 'right', sortable: false, class: 'row-style', value: 'id' }
      ]

      addFileToInstallation() {
        commonModule.showModal({ name: 'add-file-to-installation-modal', payload: { installation: this.installation } })
      }

      async downloadFile(file: Record<string, any>) {
        this.isDowloadingFile = true;
        try {
          let downloadFile = await installationsModule.getInstallationFile({installationId: file.installation_id, fileId: file.id} );
          downloadFile = new File([downloadFile], file.original_name);
          FileSaver.saveAs(downloadFile);
        } finally {
          this.isDowloadingFile = false;
        }
      }

      downloadExportLengthCheck() {
        return this.files?.length > 0;
      }

      async donwloadFilesExport() {
        this.isDownloadingExport = true;
        const data = {
          user_timezone: dayjs.tz.guess(),
          language: localStorage.getItem('lang'),
          format: 'zip',
          installation_id: this.installation.info.id,
        };

        try {
          const company = await companyModule.getCompanyInfo();
          const filename = `${templatesFilenameLanguage()}_${company.entity_name}_DfB_${data.installation_id}_files_${dayjs().format('YYYY_MM_DD_HH_mm_ss')}.zip`.replace(/ /g, '_');
          const zip = await installationsModule.getInstallationSideviewFilesExport(data);
          const file = new File([zip], filename);
          FileSaver.saveAs(file);
        } finally {
          this.isDownloadingExport = false;
        }
      }

      async editFile(file: Record<string, any>) {
        commonModule.showModal({ name: 'edit-installation-file-modal', payload: { file: file } })
      }
      async deleteFile(file: Record<string, any>) {
       commonModule.showModal({ name: 'delete-installation-file-modal', payload: { file: file } })
      }

      formatDate (date: Date): string {
        return TimeUtil.formatDateTime(date)
      }

      get files() {
        return this.installation?.files?.list ? this.installation.files?.list : [];
      }

      get usedSpace() {
        return this.installation?.files?.details?.total_used_space_mb;
      }

      get totalSpace() {
        return this.installation?.files?.details?.maximum_free_space_mb;
      }

      get reachedSpaceLimit() {
        return this.installation?.files?.details?.remaining_available_space_mb <= 0;
      }

      get usedSpacePercentage() {
        return (this.usedSpace / this.totalSpace ) * 100;
      }

      get progressColor() {
        if (this.usedSpacePercentage <= 50) {
          return 'success';
        } else if (this.usedSpacePercentage <= 80) {
          return 'orange';
        } else {
          return 'red';
        }
      }

      get tableIsLoading() {
        return installationsModule.sideviewTableIsLoading || this.isDowloadingFile;
      }

    };
    